import { Injectable } from '@angular/core';
import { AppointmentFieldsInputType } from '@libs/types/src/scheduler/input-type/scheduler.input-type';
import {
    schedulerAppointmentFrag,
    schedulerVoucherPrescribedMedicalProceduresFrag,
} from './types/scheduler.gql-types';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { AppointmentGridObject } from '@libs/types/src/scheduler/object-type/scheduler.object-type';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { OkObject, VoucherPrescribedMedicalProcedureGridObject } from '@it2go/types';
import {
    SchedulerCheckoutObject,
    SchedulerCheckoutObjectGrid,
} from '@libs/types/src/scheduler/object-type/scheduler-checkout.object';
import { SchedulerCheckoutCreateInput } from '@libs/types/src/scheduler/input-type/scheduler-checkout.create-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { SchedulerCheckoutPatchInput } from '@libs/types/src/scheduler/input-type/scheduler-checkout.patch-input';

@Injectable({ providedIn: 'root' })
export class SchedulerGqlServiceV2 extends GqlServiceV2 {

    public schedulerBatchUpdate(input: AppointmentFieldsInputType, fragment = schedulerAppointmentFrag) {
        return this.mutate(
            `
                mutation($input: AppointmentFieldsInputType!) {
                    scheduler {
                        batchUpdate(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getSchedulerEvents(input: GridInput | null = null, fragment = schedulerAppointmentFrag) {
        return this.query<AppointmentGridObject>(
            `
                query($input: GridInput) {
                    scheduler {
                        getEvents(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public removeSchedulerErrors(input: IdInput, fragment: string = 'ok') {
        return this.mutate<SchedulerCheckoutObject>(
            `
                mutation($input: IdInput!) {
                    scheduler {
                        removeErrors(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getSchedulerCheckouts(input: GridInput, fragment: string) {
        return this.query<SchedulerCheckoutObjectGrid>(
            `
                query($input: GridInput!) {
                    schedulerCheckout {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createSchedulerCheckout(input: SchedulerCheckoutCreateInput, fragment: string) {
        return this.mutate<SchedulerCheckoutObject>(
            `
                mutation($input: SchedulerCheckoutCreateInput!) {
                    schedulerCheckout {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public patchSchedulerCheckout(input: SchedulerCheckoutPatchInput, fragment: string) {
        return this.mutate<SchedulerCheckoutObject>(
            `
                mutation($input: SchedulerCheckoutPatchInput!) {
                    schedulerCheckout {
                        patch(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteSchedulerCheckout(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    schedulerCheckout {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getSchedulerVoucherPrescribedMedicalProcedures(input: GridInput, fragment = schedulerVoucherPrescribedMedicalProceduresFrag) {
        return this.query<VoucherPrescribedMedicalProcedureGridObject>(
            `
                query($input: GridInput) {
                    voucherPrescribedMedicalProcedure {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

}
